import { NavLink } from 'react-router-dom';
import { LayoutGrid, Home, MessageCircle, Users, Settings } from 'lucide-react';
import { routes } from '@/lib/routes';

const tabs = [
  { to: routes.app.hub(), label: 'Hub', icon: LayoutGrid, exact: true },
  { to: routes.innerTeam.home(), label: 'Start', icon: Home, exact: true },
  { to: routes.innerTeam.discovery(), label: 'Entdecken', icon: MessageCircle, exact: false },
  { to: routes.innerTeam.teamDashboard(), label: 'Mein Team', icon: Users, exact: false },
  { to: routes.app.userSettings(), label: 'Einstellungen', icon: Settings, exact: false },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-card border-t border-border pb-safe">
      <div className="flex items-stretch h-16 max-w-lg mx-auto">
        {tabs.map(({ to, label, icon: Icon, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 gap-1 text-xs transition-colors ${
                isActive
                  ? 'text-primary font-medium'
                  : 'text-muted-foreground hover:text-foreground'
              }`
            }
          >
            <Icon size={20} strokeWidth={1.75} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
